import HopeService from '@/service/hope'
const contextBase = 'garantia/mensualidad/';

export default{
    getMensualidadAnio(anio, id){
        return HopeService().get(contextBase+anio+'/'+id);
    },
}